const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {rmaLookupFieldDropdown, rmaLookupFXOFieldDropdown} from "./filter/rmaLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {keyDefaultFalseOption} from '../../utilities/general';
let actionList = actionOptions;
const targetSelector = "#lookup-rma";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let detailLinkTemplate = require('./html/detailLinkTemplate.html');
let customerNameTemplate = require('./html/customerNameTemplate.html');

run(targetSelector, ()=>{
	const entryElement = $(targetSelector);
    const dataTableComponentData =  entryElement.data("rma-data");
    const statusList = entryElement.data("status-list");
    const rmaPortletFXOPerm = entryElement.data("fxo-perm");
    const rmaPortletAddPerm = entryElement.data("add-perm");
		const rmaPortletEditPerm = entryElement.data("edit-perm");
		const rmaCasAccountExists = entryElement.data("rma-cas-account");
		const retailerName =  entryElement.data("retailer-name");

    const viewRmaDetailURL =  entryElement.data("view-details-url");
    const fxoReturnsURL =  entryElement.data("fxo-returns-url");
    const changeRmsStatusUrl =  entryElement.data("change-status-url");
    const generateReturnLabelUrlForDownload =  entryElement.data("return-label-url");
    const downloadReturnLabelUrlForDownload =  entryElement.data("download-return-label-url");
    const filterSearchUrl =  entryElement.data("filter-search-url");
    const generateExportUrl =  entryElement.data("export-url");

    const portletNamespace =  entryElement.data("portlet-namespace");
    const shouldCheckCache  =  entryElement.data("should-check-cache");

    const orderFilterData =  entryElement.data("table-filter-data");

    const savedViews  =  getSavedViews(entryElement);
    const saveViewURL  =  entryElement.data("save-view-url");
		const deleteViewURL  =  entryElement.data("delete-view-url");
		const hasSubRetailers = entryElement.data("rma-has-subretailer");
		const fxoLabelReprintUpdateUrl = entryElement.data("fxo-label-reprint-update-url");
		const fxoGeneratelabelUrl = entryElement.data("fxo-generate-label-url");
    //  E-99299 Poly Mailer Attention Message START 
    const polyMailerDescMsg = entryElement.data("poly-mailer-desc-msg");
    const ployMailerTitleMsg = entryElement.data("ploy-mailer-title-msg");
    const enrolledInPolyMailer = entryElement.data("enrolled-in-poly-mailer");
    const roleAllowed = entryElement.data("role-allowed");
    //  E-99299 Poly Mailer Attention Message END 
	//MMC E-181400
	const rmaMmcFlag = entryElement.data("rma-mmc-flag");
	const rmaMmcReceiptType = entryElement.data("rma-mmc-receitp-type");
	//MMC
		let desktopColumns;
		if(hasSubRetailers){
			desktopColumns =  [
				{
					data: "rmaStatus",
					render : renderActionWrap,
					orderable:false,
					class: 'dtc-action-column',
					title: "Actions",
				},
				{
					data: "rmaNumber",
					title: "RMA Number",
					render: createDetailLink,
					class: 'dtc-min-width-sm'
				},
				{
					data: "rmaFromLastName",
					title: "Customer",
					render: createCustomerName,
					 class: 'dtc-min-width-md'

				},
				{
					data: "rmaFromEmail",
					title: "Email",
					 class: 'dtc-min-width-md'
				},
				{
					data: "rmaChrId",
					title: "Merchant",
					class: 'dtc-min-width-md',
					orderable:false
				},
				{
					data: "rmaStatus",
					title: "Status",
					render: renderStatusPill,
					class: 'dtc-min-width-md'
				},
				{
					data: "rmaCreatedDate",
					title: "Created on",
					render: formateDate,
					class: 'dtc-min-width-md'
				},
				{
					data: "rmaCreatedDate", //or rmaCreatedTime if need by timestamp
					"visible": false // hidden column used to sort/order rmaCreatedDate formatted visible column
				}
			];
		}else{
			desktopColumns =  [
				{
					data: "rmaStatus",
					render : renderActionWrap,
					orderable:false,
					class: 'dtc-action-column',
					title: "Actions",
					},
				{
					data: "rmaNumber",
					title: "RMA Number",
					render: createDetailLink,
					class: 'dtc-min-width-sm'
				},
				{
					data: "rmaFromLastName",
					title: "Customer",
					render: createCustomerName,
					 class: 'dtc-min-width-md'

				},
				{
					data: "rmaFromEmail",
					title: "Email",
					 class: 'dtc-min-width-md'
				},
				{
					data: "rmaStatus",
					title: "Status",
					render: renderStatusPill,
					class: 'dtc-min-width-md'
				},
				{
					data: "rmaCreatedDate",
					title: "Created on",
					render: formateDate,
					class: 'dtc-min-width-md'
				},
				{
					data: "rmaCreatedDate", //or rmaCreatedTime if need by timestamp
					"visible": false // hidden column used to sort/order rmaCreatedDate formatted visible column
				}
			];
		}

    var disableCancel = dataTableComponentData.disableCancel;

    var submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();

	let exportModal = new buildExport();

    const extraDetailForCacheFromServer  =  entryElement.data("extra-detail-for-cache-from-server");
    const criteriaObjectFromServer  =  entryElement.data("filter-criteria-from-server");

    let targetObject = "";
    let totalRecordCount = 0;
    let lookupFieldDropdown = rmaLookupFieldDropdown;
    let rmaMobileColumns = "";

    let selectedRows = "";

    if(rmaPortletFXOPerm) {
    	lookupFieldDropdown = rmaLookupFXOFieldDropdown;
    }

    if(shouldCheckCache)
    {
		targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
	}

	if(_.has(dataTableComponentData, "page")) {
		totalRecordCount = dataTableComponentData.page.totalElements;
	}

	function getSavedViews(entryElement) {
		let views = entryElement.data("saved-views");
	    if(rmaPortletFXOPerm) {
			_(views[0].columns).map((viewColumn, rowIdx)=>{
			  if(viewColumn.title === "Status") {
			  	viewColumn.active = false; // This is to hide status column for FXO user
			  	return viewColumn;
			  } else {
			  	return viewColumn;
			  }
			});
	    }

	    return views;
	}

	function renderPill(data, type, row) {
    	return data;
  	}

    function createDetailLink(data, type, row) {
    	let newRender;

	    newRender = render(
	      detailLinkTemplate, {
	        id: row.rmaId,
	        name: row.rmaNumber,
	        url: viewRmaDetailURL,
	        portletnamespace: portletNamespace
	      }
	    );
	    return newRender;
    }

    function createCustomerName(data, type, row) {
    	let newRender;

	    newRender = render(
	      customerNameTemplate, {
	        firstname: row.rmaFromFirstName,
	        lastname: row.rmaFromLastName
	      }
	    );
	    return newRender;
    }

	function renderStatusPill(data, type, row){
		let status =  data;
		if(status  === "Pending - Address ID Missing") {
			return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
		} else if(status  === "Pending - RA Required") {
			return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
		} else if(status === "Received") {
			return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if(status  === "Canceled") {
			return "<div class='q-pill q-block q-pill-light-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if (status === "Approved") {
			return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if (status === "ASN Sent") {
			return "<div class='q-pill q-block q-pill-white-and-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if(status === "Partially Received") {
			return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		}else if(status === "Pending - Unauthorized Items") {
			return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
		} else if (status === "RMA Sent To SAP") {
			return "<div class='q-pill q-block q-pill-white-and-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if(status  === "Pending") {
			return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
		} else if(status  === "Closed to Returns") {
			return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		} else if(status  === "RMA Rejected") {
			return "<div class='q-pill q-block q-pill-light-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
		}
		return "";
	}

	function formateDate(createdDate, type, data) {
		if(createdDate != null && createdDate != ""){
		  var date = moment(createdDate).toDate(); // format yyyy-MM-DD
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var oneDay = 24*60*60*1000;
		  var diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
	}

	 let defaultMobileColumns = [
	    {
	      data: "rmaNumber",
	      title: "RMA Number",
	      render: createDetailLink
	    },
	    {
	      data: "rmaFromLastName",
	      title: "Customer",
	      render: createCustomerName
	    },
	    {
	      data: "rmaFromEmail",
	      title: "Email"
	    },
	    {
	      data: "rmaStatus",
	      title: "Status",
	      render: renderStatusPill
	    }
	];

	rmaMobileColumns = defaultMobileColumns;

    if(rmaPortletFXOPerm) {
    	rmaMobileColumns.splice(-1); // remove last status column for mobile as status should not be shown to FXO
    }

    var rmaLookup = new LookupTable({
	    // REQUIRED - Set a target element
	    target: $("#lookup-rma-wrapper"),
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: rmaMobileColumns,
	   // tableFilters: {
	   //    data: orderFilterData,
	   //  },

	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: (targetObject != "" ? targetObject.value[0] : "")

	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
		  selected: (targetObject == "" ? "" : targetObject.key),
	      columns: lookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
   		savedViews: savedViews,
   		bulkSelect: false,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	    data: dataTableComponentData.content,
	    columnDefs: [
				{
					// Sort column 4 (formatted date) by column 6 (hidden column)
					"orderData":[ 6 ], // hidden column used to sort/order rmaCreatedDate formatted visible column
					"targets": [ 5 ]
				}
			],
	    order: [
	       [5, 'desc'],//default order
	    ],
	    columns:desktopColumns
	    },
	   //  tableColumnModal: {
      	//	data: rmaLookupColumnsPopup
    	//},
	    paginationData:dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Returns",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "rma"
	    },
	 	onBulkSelectChange: function() {
		    selectedRows = rmaLookup.getBulkSelectedData();
    	    $("th.dtc-action-column").html(renderActionHeaderWrap());
		    if (selectedRows.length >= 2) {
				$(".action-header-btn .base-btn").removeClass('disabled');
			}else{
			    $(".action-header-btn .base-btn").addClass('disabled');
			};
		},
	    onFetch: function() {
	      let currentData = rmaLookup.generateData();
	      rmaLookup.showLoadingOverlay();
       	  //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
       	  if(isOnlyLookupDataUpdate(currentData)){
       	  	setTimeout(() => {
				doAjax({url: filterSearchUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
	      	},SUCCESS_MODAL_TIMEOUT);
		   }else if(isNew(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isEdit(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isDeleteView(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }
		}
    });

	function filterSuccessFun(data){
		let rmas = data.content;
		let page = data.page;
		rmaLookup.setNewData(rmas);
		rmaLookup.setPaginationData(page)
		pushFilterSessionCacheState();
		totalRecordCount = page.totalElements;
		rmaLookup.hideLoadingOverlay();
		setExportData(rmaLookup.generateData());
		//$(".data-table-component").DataTable().columns('.status-column').visible( false );
	}

	function savedViewSuccess(data){
	    let rmas = data.lookupRmaJSON.content;
	    let page = data.lookupRmaJSON.page;
	    rmaLookup.setNewData(rmas);
	    rmaLookup.setPaginationData(page);
	    rmaLookup.setNewSavedViewData(data.savedView, "newSavedView");
	  	pushFilterSessionCacheState();
	  	totalRecordCount = page.totalElements;
	    rmaLookup.hideLoadingOverlay();
	    setExportData(rmaLookup.generateData());
	}


	function savedEditViewSuccess(data){
	    let rmas = data.lookupRmaJSON.content;
	    let page = data.lookupRmaJSON.page;
	    rmaLookup.setNewData(rmas);
	    rmaLookup.setPaginationData(page);
	    rmaLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	  	pushFilterSessionCacheState();
	  	totalRecordCount = page.totalElements;
	    rmaLookup.hideLoadingOverlay();
	    setExportData(rmaLookup.generateData());
	}


	function delteViewScussFun(data){
		let rmas = data.lookupRmaJSON.content;
	    let page = data.lookupRmaJSON.page;
		rmaLookup.removeSavedView(data.target);
		rmaLookup.setNewData(rmas);
	    rmaLookup.setPaginationData(page);
	    totalRecordCount = page.totalElements;
		rmaLookup.hideLoadingOverlay();
		setExportData(rmaLookup.generateData());
	}

	function errorFun(data){
   	    rmaLookup.hideLoadingOverlay();
	}

	rmaLookup.init();

    if(rmaPortletFXOPerm) {
    	$('.new-saved-view-btn').remove(); // Hide the Add View button so that FXO user cannot create new filters.
    }

	//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
	function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
    };

    function renderActionHeaderWrap() {
  	    let statusTarget = actionList['all'];
	    let newRender;
	    let data = "";
	    let row = "";
	    newRender = render(
	      actionHeaderDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row)
	      }
	    );
	    return newRender;
    };

    function renderActionCellList(list,data,row) {
	    let renderedList;
	    renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, {
	          icon: item.icon,
	          title: item.title,
	          cls: item.cls,
	          disabled:checkDisableForGivenAction(data,row,item.title)
	        }
	      )
   		 });
	    return renderedList.join('');
    };

	function checkDisableForGivenAction(data,row,actionName) {
	 	if(isRowLevelActionCheck(data)){
	    	return callBusinessLogicToDisableAction(data,row,actionName);
	    }else{
	      	let isTrue = false;
	    	_(selectedRows).map((item)=>{
	      		if(callBusinessLogicToDisableAction(item.data.rmaStatus,item.data,actionName)){
	    			if (!isTrue){
	    				isTrue = true;
	    			}
	    		}
	        });
	    	return isTrue;
		}
	};

	function isRowLevelActionCheck(data) {
		return isPresent(data);
	}

	// Note this method will return true if we want to disable action, else return false if we want to enable
	function callBusinessLogicToDisableAction(status,row,actionName) {
		if (isPresent(status)) {
			//HB-7753, Overriding Condition, If Not Recieved and Does not have a CAS account for
			if(row.rmaStatus != "Received" && !rmaCasAccountExists) {
				if(actionName === "View Label") {
					if(rmaPortletFXOPerm === true) {
							return false;
					}
				}
			}
			//HB-7753, Remaining Conditions for the View Actions same as before, except for Recieved, FXO show the view Label

			if(row.rmaStatus === "Received") {
				if(actionName === "View Label") {
				 return false;
				} else if(actionName === "Track Return") {
						if(rmaPortletFXOPerm === true) {
							return true;
						} else {
							return false;
						}
				}
			}
			else if(row.rmaStatus === "Canceled") {
				if (actionName === "Approve Return") {
					if(rmaPortletEditPerm === true) {
						return false;
					}
				}
			}
			else if(row.rmaStatus === "Approved") {
				if(actionName === "View Label" || actionName === "Track Return") {
					if(!rmaPortletFXOPerm === true) {
						return false;
					}
				} else if(actionName === "Cancel Return") {
						if(rmaPortletEditPerm === true) {
												if(isPresent(row.asnStatus)) {
														if(row.asnStatus != "Receiving" && row.ansStatus !="Complete"){
																return false;
														}
												} else {
														return false;
												}
						}
						else if(rmaPortletFXOPerm === true) {
												return true;
						}
				} else if(actionName === "Start Return") {
						if(rmaPortletFXOPerm === true) {
									return false;
						}
				}
			}else if(row.rmaStatus === "Pending - RA Required" || row.rmaStatus === "Pending - Address ID Missing"){
				if(rmaPortletEditPerm === true) {
					if(actionName === "Cancel Return") {
						return false;
					}
				}
			}
			return true;
		}
	}

    function shallAllowClick(currentObj){
   		return 	!($(currentObj).hasClass("disabled"));
    }

	$('body').on('click', '.view-label, .cancel-return, .approve-return, .track-return, .start-return', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)) {
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			let parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			let row = $(".data-table-component").dataTable().api().row(parent);

			if($(this).hasClass('view-label')) {
				processViewLabel(row);
			} else if($(this).hasClass('cancel-return')) {
				processCancelReturn(row);
			} else if($(this).hasClass('approve-return')) {
				processApproveReturn(row);
			} else if($(this).hasClass('track-return')) {
				processReturnTracking(row);
			} else if($(this).hasClass('start-return')) {
				processFxoReturn(row);
			}
		}
	});

	function processViewLabel(row) {
		$("#labelModal .title").html('&nbsp;-&nbsp;RMA: ' + row.data().rmaNumber);
		$("#labelModal").modal("show");

		$(`#${portletNamespace}printLabel`).click( function() {
			window.open(generateReturnLabelUrlForDownload + '&rmaIdForShipping=' + row.data().rmaId ,'window1');
		});

		$(`#${portletNamespace}saveLabel`).click( function() {
			window.open(downloadReturnLabelUrlForDownload + '&rmaIdForShipping=' + row.data().rmaId ,'window1');
		});
	}

	function processCancelReturn(row) {
		$("#cancelModal").data('row', row).modal("show");

		$(`#${portletNamespace}cancelReturn`).click( function() {
		    cancelReturn(row);
		});
	}

	function processApproveReturn(row) {
		$("#approveModal").data('row', row).modal("show");

		$(`#${portletNamespace}approveReturn`).click( function() {
			cancelReturn(row);
		});
	}

	function cancelReturn(row) {
		// OLD: in controller, if current status is Canceled, it set to Approved. If current status is Approved, it changes to Canceled
		// Controller code has changed, now it will only set to status given

	  submitModalFlow.showLoadingModal();
		$.ajax({
			url: changeRmsStatusUrl,
			type: 'POST',
			data: "selectedRmaId=" + row.data().rmaId + "&rmaStatus=Canceled",
			dataType: 'text',
			success: function(data){
			    submitModalFlow.showSuccessModal();
				setTimeout(function() {
				  submitModalFlow.hideAllModals();
			     }, SUCCESS_MODAL_TIMEOUT);
				row.data().rmaStatus = $.trim(data);
				row.data(row.data()).draw();
			}
		});
	}

	function processReturnTracking(row) {
		AUI().use('liferay-portlet-url', function(A) {
        	let renderURL = Liferay.PortletURL.createRenderURL();
        	renderURL.setName("shipmentTracking");
        	renderURL.setWindowState("exclusive");
        	renderURL.setPortletId("shipmenttracking_WAR_commerceportlet");
        	renderURL.setParameter("tracking-number", row.data().rmaTrackingNumber);
        	renderURL.setParameter("carrier", "Fedex");
        	renderURL.setParameter("retailerId", row.data().rmaRetId);
        	let url = renderURL.toString();

			$(`#${portletNamespace}trackingLoading`).show();
			$(`#${portletNamespace}trackingError`).hide();
			$(`#${portletNamespace}trackingDiv`).html("");
			$("#trackingModal").modal("show");

        	$.ajax({
		        url: url,
		        cache: false,
		        type: "POST",
		        success: function(response) {
		        	$(`#${portletNamespace}trackingLoading`).hide();
		            $(`#${portletNamespace}trackingDiv`).html(response);
		        },
		        error: function(){
		        	$(`#${portletNamespace}trackingError`).show();
		        }
		    });
    	});
	}

	function processFxoReturn(row) {		
		if(rmaCasAccountExists || (rmaMmcFlag == true && rmaMmcReceiptType == true )) {	
			$('#multipleRmaSelectionHidden').val(row.data().rmaId);
		  $("#fxo-rma-return-form").submit();			
	  } else {
			 $("#no-cas-participation-modal").modal("show");
          if (enrolledInPolyMailer == true && roleAllowed == true) {
              $("#fxo_nonpolymailer").hide();
              $("#fxo_polymailer").show();
              $("#polyMailerTitleMsg").html(ployMailerTitleMsg);
              $("#polyMailerDescMsg").html(polyMailerDescMsg);
              if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
                    $("#fxo-merchant-name-poly").html(retailerName);
                } else {
                    $("#fxo-merchant-name-poly").html(row.data().rmaChrId);
              }
              $("#poly-mailer-used-radio-opt1").prop("checked", false);
              $("#poly-mailer-used-radio-opt2").prop("checked", false);
              if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
                    $("#fxo-merchant-name-nonpoly").html(retailerName);
                } else {
                    $("#fxo-merchant-name-nonpoly").html(row.data().rmaChrId);
              }
              $("#print-label-btn").addClass("disabled");
          } else {
              $("#fxo_nonpolymailer").show()
              $("#fxo_polymailer").hide();
              $("#fxo_polymailer").hide();
              if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
                    $("#fxo-merchant-name-nonpoly").html(retailerName);
                } else {
                    $("#fxo-merchant-name-nonpoly").html(row.data().rmaChrId);
              }
          }		
		}
		$("#print-label-btn").on("click", function() {
				let resizeLabel = false;
				let rmaReceivingType = row.data().rmaReceivingType;

				$("#no-cas-participation-modal").modal("hide");				
		    if (rmaReceivingType == 'single_ship') {
			    resizeLabel = true;
		    }
				window.open(fxoGeneratelabelUrl + '&rmaIdForShipping=' + row.data().rmaId + '&resizeLabel=' + resizeLabel
				+ '&rmaReceivingType=' + rmaReceivingType,'window1');
				
				submitFxoLabelReprintUpdate(row);
			});
	}
  
  $(".poly-mailer-radio").on('change', function(e) {
        $("#print-label-btn").removeClass("disabled");
        return true;
    })
  
	function submitFxoLabelReprintUpdate(row) {	
    var radioValue = $("input[name='poly-mailer-used-radio']:checked").val();
		var url = fxoLabelReprintUpdateUrl + "&rma-number-capture="+row.data().rmaNumber + "&poly-mailer-used-radio=" + radioValue;
		
		$.ajax({
					url : url,
					type : 'POST',
					beforeSend : function() {
						$.blockUI({
							message : 'Please Wait...'
						});
					},
					complete : function() {
						$.unblockUI();
					},
					success : function(resp) {
					},
					error : function(xhr, status, error) {}
				});
	}
	
	function initExport() {
		let exportObj  =  {
			title : $(targetSelector).data("export-popup-title"),
			exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
			exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
			exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
		};

		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl,currentData);
		exportModal.setExportCount(currentData.totalElements);
	}

	initExport();
	setExportData(rmaLookup.generateData());

	// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
  	handleCustomDropdownEvents();

    $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/rma/lookup.js